<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld v-if="false" msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import {getqualification_list} from "../service/getData"
export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  mounted(){
		// console.log(111111111111111)
  },
  methods:{

    reqeust(){
      getqualification_list()
    }

  }
}
</script>
